import Cookies from 'js-cookie'
import URI from 'urijs'
import { COOKIE_DOMAIN, KEY_NAMES } from '../constants'

const setSelectedStore = targetStore => {
  return Cookies.set(KEY_NAMES.selectedStore, targetStore.code, {
    domain: COOKIE_DOMAIN,
    expires: 360,
    path: '/',
  })
}

export const redirectStore = (targetStore, currentStore, suffix) => {
  const uri = URI(window.location.href)
    .hostname(targetStore.hostname)
    .addQuery('ref', `${currentStore.code}_store_${suffix}`)

  setSelectedStore(targetStore)
  window.location.href = uri.href()
}
